import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function NewsList() {
  const latestArticles = getLatestArticles(8);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          <a href="#latest-news" className="hover:text-primary-600 transition-colors">📰 最新爆料</a>
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base">黑料24小时不打烊，每日更新最新吃瓜资讯</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300"
          >
            <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between">
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{article.excerpt}</p>
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2 flex-wrap">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                  {article.category}
                </span>
                <span>{article.date}</span>
                <span className="flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-eye-line text-xs"></i>
                  </span>
                  {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-8 md:mt-10">
        <Link
          to="/category/mingxing-heiliao"
          className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 hover:bg-foreground-800 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap"
        >
          查看更多爆料
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}